import { HttpClient } from '@angular/common/http'
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { AppService } from '../../services/prod/app.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'
import { CoreSettingsService } from '../../settings/core-settings.service'
import { ISocialContact } from '../../types/common.type'

export interface IYoutubeVideo {
  id: string
  src: string
  url: string
}

@Component({
  selector: 'bmcore-youtube-block',
  templateUrl: './bmcore-youtube-block.component.html',
  styleUrls: ['./bmcore-youtube-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreYoutubeBlockComponent implements OnInit {
  lg: LgType
  youtubeChannel = 'https://www.youtube.com/channel/UCPAVY2t0L-KldWAvuoZUxog'
  beatmakerName = ''
  youtubeList: Array<IYoutubeVideo> = [
    { id: '0', src: 'youtube-cover-stub-1.jpg', url: 'https://www.youtube.com/watch?v=Ngl46xLavp0' },
    { id: '1', src: 'youtube-cover-stub-2.jpg', url: 'https://www.youtube.com/watch?v=K6nJ8Bm_qzQ' },
    { id: '2', src: 'youtube-cover-stub-3.jpg', url: 'https://www.youtube.com/watch?v=nRXL2-JvyAM' }
  ]
  socialContacts: Array<ISocialContact>

  youTubeChannelId = 'UCJBJLlmdREol7cLVex7digA'
  youTubeApiKey = 'AIzaSyB8HvcAWY5bBLmyScW7KhuTyiPOCKRDH3A' // https://console.developers.google.com/apis/credentials
  public BaseAssetsURL: string

  constructor(
    private i18nService: I18nService,
    private appService: AppService,
    private http: HttpClient,
    coreSettingsService: CoreSettingsService
  ) {
    this.BaseAssetsURL = coreSettingsService.settings.urls.assetsURL
  }

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getBeatmakerData()
  }

  getBeatmakerData() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res) {
        this.beatmakerName = res.beatmakerName
        this.socialContacts = res.contacts
        res.contacts.forEach(contact => {
          if (contact.type === 'YOUTUBE') {
            this.youtubeChannel = contact.url
            // TODO: Временный url, т.к. сервер приводит URL к нижнему регистру
            this.youtubeChannel = 'https://www.youtube.com/channel/UCJBJLlmdREol7cLVex7digA'
            this.youtubeChannel = this.youtubeChannel.substring(32)
            this.getUploadIdFromYouTube()
          }
        })
      }
    })
  }

  // https://stackoverflow.com/a/36387404
  getUploadIdFromYouTube() {
    // 1 step. Get uploads id
    this.http
      .get(
        `https://www.googleapis.com/youtube/v3/channels?id=${this.youTubeChannelId}&key=${this.youTubeApiKey}&part=contentDetails`
      )
      .subscribe((res: any) => {
        let uploadsId = res.data.items[0].contentDetails.relatedPlaylists.uploads
        // todo: delete hardcode
        uploadsId = 'UUJBJLlmdREol7cLVex7digA'
        this.getLastVideosFromYoutube(uploadsId)
      })
  }

  getLastVideosFromYoutube(uploadsId: string) {
    // 2 step. Get videos
    this.http
      .get(
        `https://www.googleapis.com/youtube/v3/playlistItems?playlistId=${uploadsId}&key=${this.youTubeApiKey}&part=snippet&maxResults=3`
      )
      .subscribe((res: any) => {})
  }
}
